// extracted by mini-css-extract-plugin
export default {"info_root":"gliprint_info_root__WdGaQ","close_btn":"gliprint_close_btn__AUCGf"};